module.exports = __webpack_public_path__ + "media/images/shared/icon-angelport-cf901ea22b58d29bdcd52754deda0de1.svg";